import {
  DEFAULT_IMAGE_HEIGHT,
  DEFAULT_IMAGE_WIDTH,
  DEFAULT_TEXT_HEIGHT,
  DEFAULT_TEXT_WIDTH
} from '~/constant'
import ProjectImageAsset from '~/models/ProjectData/ProjectImageAsset'
import ProjectTextAsset from '~/models/ProjectData/ProjectTextAsset'

export const correctAssetWidthNHeight = assets => {
  assets.forEach(asset => {
    if (asset instanceof ProjectImageAsset) {
      let defaultWidth = DEFAULT_IMAGE_WIDTH
      let defaultHeight = DEFAULT_IMAGE_HEIGHT
      if (asset.layerId) {
        defaultHeight = asset.height > 0
          ? asset.height
          : (asset.settings?.originalSize?.height || 0)
        defaultWidth = asset.width > 0
          ? asset.width
          : (asset.settings?.originalSize?.width || 0)
        // eslint-disable-next-line no-param-reassign
        asset.width = defaultWidth
        // eslint-disable-next-line no-param-reassign
        asset.height = defaultHeight
      }
    } else if (asset instanceof ProjectTextAsset && !asset.settings?.size) {
      // Legacy projects may contain placeholder top-level text dimensions.
      // The current TextAsset will then measure and initialize its real box in preview.
      // eslint-disable-next-line no-param-reassign
      asset.width = DEFAULT_TEXT_WIDTH
      // eslint-disable-next-line no-param-reassign
      asset.height = DEFAULT_TEXT_HEIGHT
    }
  })
}
